export default "__VITE_ASSET__Cqv2U5y4__"